/* eslint-disable react/prop-types */
import React, { useEffect, useState,useRef } from 'react';
import PropTypes from 'prop-types';
import './header.scss';
import Icon, { IconType, IconSize } from '../../atoms/icon/icon';
import Menu from '../../molecules/menu/menu';
import MenuItem from '../../atoms/menuItem/menuItem';
import HamburgerMenu from '../../molecules/hamburguerMenu/hamburgerMenu';
import routes, { getRoute, getLink } from '../../../routes/route';
import ChangePasswordPopup from '../../molecules/changePasswordPopup/changePasswordPopup';
import Button from '../../atoms/button/button';
import { decryptText } from '../../../utils/cookies';
import { getCookie } from '../../../store/sessionStore';
import Version from '../../atoms/version/version';
import ButtonPopup from '../../atoms/buttonPopup/buttonPopup';
import FormInputTypes from '../../atoms/formEnums/formInputTypes';
import tableDocumentation from '../../../config/tableDocumentation';
import permissionTypes from '../../atoms/permissionsGate/permissionTypes';
import { checkEnvironment } from '../../../utils/mainUtils';
import { httpGet } from '../../../store/externalCalls/httpCalls';
import { useDispatch, useSelector } from 'react-redux';
import { setMainMenu } from '../../../store/actions/mainMenuActions';
import { storeStructure } from '../../../store/reducers';
/**
 * General XMS app with app selection, and profile options.
 * @param {*} props
 */
const Header = (props) => {
  const {
    children,
  } = props;
  const serializedState = getCookie('state');
  const [popupState, setPopupState] = React.useState(false);
  const [permission, setPermission] = useState(parseInt(decryptText(getCookie('permission'))));
  const [organization, setOrganization] = useState(parseInt(decryptText(getCookie('organization'))));
  const backgroundColor = process.env.REACT_APP_BACKGROUND_COLOR;
  const fontColor = process.env.REACT_APP_MENU_FONT_COLOR;
  const envTitle = process.env.REACT_APP_ENV_TITLE;
  const [isOpen, setIsOpen] = useState("no");
  const dispatch = useDispatch();
  const myMenus = useSelector((state) => state[storeStructure.MainMenu]);
  const menuRef = useRef(null);
  useEffect(() => {
    if (myMenus && myMenus.length > 0) return;
    httpGet('getMainMenu')
      .then((res) => {
        const items = res?.data ?? res;
        dispatch(setMainMenu(items));
      })
      .catch((err) => console.log('err', err));
  }, [myMenus]);
  useEffect(()=>{
    if(envTitle){
      checkEnvironment(envTitle);
    }
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen("no");
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  },[]);
 
  return (
    <>
      <nav
        className="header__navbar navbar fixed-top" style={{backgroundColor: "#"+backgroundColor}}
      >
        {myMenus && myMenus.length>0 && 
            <div  ref={menuRef}>
              <HamburgerMenu isOpen={isOpen} id="hamburguerMenu" className="hamburguerMenu" key="menu0" onOpen={()=>{setIsOpen("si");}} onClose={()=>{setIsOpen("no");}}>
                {myMenus && myMenus.length>0 && myMenus.map((menu,index)=>{
                  return( 
                  <MenuItem className={
                      "header__floating-menu-item " + (menu.submenu ? "header__submenu" : "")
                    }  key={index} to={menu.url} scopes={[menu.permission]}>
                    {menu.name}
                  </MenuItem>
                  );
        
              } )}
              </HamburgerMenu>
              <Menu className="d-inline-block">
                <div>
                    <MenuItem className="header__logo" key="headerMenu1" to="/">
                      <img src={`${process.env.REACT_APP_FRONTEND_URL}/ybvr_medium.png`} width="80" alt="YBVR logo" />
                    </MenuItem>
                </div>
                <div className="header__gap"></div>
                <div key="headerMenu2" to="/" className="header__env--menu" >
                  <div className="header__env">
                    {envTitle}
                  </div>
                </div>
              </Menu>
              {children}
            </div>
          }
          <Menu right className="header__right-menu">
            <div className="header__user" style={{color: "#"+fontColor}}>Hello, {JSON.parse(serializedState).sessionEmail}</div>
            <div className="header__documentation-section">
              <ButtonPopup
                id={"button-popup-documentation"}
                icon={IconType.CATALOG}
                iconSize={IconSize.LARGE}
                openUrl={"documentations"}
                iconColor={"#AFC6FF"}
                formConfig={
                  {
                    title: 'Documentation',
                    description:'XMS documentation files',
                    attributeName: 'documentation',
                    fields: [
                      {
                        attributeName: 'documentationTable',
                        type: FormInputTypes.TABLECOMPONENT,
                        mode:'NORMAL',
                        helpText: '',
                        configFile: tableDocumentation,
                      },
                    ]
                  }
                }
                value={""}
              /> 
              </div>
          <Button icon={IconType.USER} onClick={() => { setPopupState(true); }} iconSize={IconSize.LARGE} iconColor={"#"+fontColor} />
          <MenuItem to={getRoute(routes.LOGIN)}>
            <Icon icon={IconType.SINGOUT} iconSize={IconSize.LARGE} />
          </MenuItem>
        </Menu>
      </nav>
      <ChangePasswordPopup show={popupState} onChange={() => setPopupState(false)} />
    </>
  );
};

Header.propTypes = {
  /**
   * Function to setup the current app in the store
   */
  children: PropTypes.node,
};

Header.defaultProps = {
  children: '',
};

export default Header;
